import React, { useState,useEffect }  from 'react';
import {Link} from 'react-router-dom'
import axios from 'axios';

import { BASE_URL } from '../Config/Base';
import { ToastContainer, toast } from 'react-toastify';
import { Oval } from  'react-loader-spinner'

const Oatsectionmain = () => {



  useEffect(()=>{ 
    document.getElementById('Oat-ListSec').style.display = "none";
    setpop(true);
    getUser();
    SelectParticular()
    setTimeout(()=>{
      getresult();
      document.getElementById('Oat-ListSec').style.display = "block";
      setpop(false);
    },1000)
   
  }, [])


  const[pop,setpop] = useState(false);
  let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
  const token = JSON.parse(localStorage.getItem('usertoken'));
  var UserId= localStorage.getItem('UserId')

  function getUser(){


  console.log("Token", token)
  fetch(`${BASE_URL}/oat/Getoatusers`, {

    method: 'GET',

    headers: {

      "Content-type": "application/json",

      "Accept": "application/json",

      "Authorization": "Bearer " + `${token}`,

      "Access-Control-Allow-Headers": "Access-Control-Request-Headers "

    },

    //body:JSON.stringify(data)

  }).then(response => response.json())

    .then(data => {
      console.log("Data", data)
      localStorage.setItem("Data", JSON.stringify(data));
        }
    );


  }
  function SelectParticular(){
    const body =
    {
      
     id:UserId
    }
    console.log('body',body);

  
    axios({
           method:"POST",
           url :`${BASE_URL}/oat/Getparticularid`,
           data:body, 
           headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer " + `${token}`,
            }     
        }) 
        
   
        .then((response) =>{
          console.log(response.data);
     
       
          localStorage.setItem("SectionData", JSON.stringify(response.data));
          
       })
       .catch(error => {
         console.log(error);
         
       })

   }



  
   function getresult(){

     ////Admin
    
     let LoginRoleId= localStorage.getItem("RoleId");

    let CheckAdmin =LoginRoleId.includes("01")
    let alldata = localStorage.getItem("Data");
    //console.log(alldata)
    
    
    let namedata =  JSON.parse(alldata);
     //console.log(namedata)
    
    let names = namedata&&namedata.map((item) => item.userName);
       //console.log("username",names)
    
       let UserName= names.toString();
       //console.log(UserName)

    
    let loginUser =localStorage.getItem('username')
    //console.log(loginUser)
    
    let Nameresult = UserName.includes(loginUser);  
    //console.log(Nameresult)
    
    
    /*---get section data ---*/
    
    
    let Usersectiondata =  localStorage.getItem("SectionData");
    //console.log(Usersectiondata)
    
    
    let data =  JSON.parse(Usersectiondata);
     //console.log(data)
    
    let sections = data&&data.map((item) => item.section);
       //console.log(sections)
    
       let sectionstr = sections.toString();
       console.log(sectionstr);
 
       let sectionresult =sectionstr.includes('Home')
       console.log(sectionresult)
       let sectionresultA =sectionstr.includes('Entities')
       //console.log(sectionresultA)
       let sectionresultB =sectionstr.includes('Categories')
       //console.log(sectionresultB)
       let sectionresultC =sectionstr.includes('Announcement')
       //console.log(sectionresultC)
      
  
       let sectionresultD =sectionstr.includes('')
       //console.log(sectionresultD)
      
       if(Nameresult==true && sectionresultD==true){
   
    
        document.getElementById('Oat-ListSec').style.display = "block";
       }
       else{
           
        document.getElementById('Oat-ListSec').style.display = "block";
        }

        if(Nameresult==true && sectionresult==true){
   
          
          document.getElementById('Oat-Section-listA').style.display = "grid"; 
          
    
        
        }
      else{
           document.getElementById('Oat-Section-listA').style.display = "none"; 
           
        }

        if(Nameresult==true && sectionresultA==true){
   
          
          document.getElementById('Oat-Section-listB').style.display = "grid"; 
          
    
        
        }
      else{
           document.getElementById('Oat-Section-listB').style.display = "none"; 
           
        }

        if(Nameresult==true && sectionresultB==true){
   
          
          document.getElementById('Oat-Section-listC').style.display = "grid"; 
          
    
        
        }
      else{
           document.getElementById('Oat-Section-listC').style.display = "none"; 
           
        }
        if(Nameresult==true && sectionresultC==true){
   
          
          document.getElementById('Oat-Section-listD').style.display = "grid"; 
          
    
        
        }
      else{
           document.getElementById('Oat-Section-listD').style.display = "none"; 
           
        }

        if(Nameresult==true && sectionresult==false  && sectionresultA==false && sectionresultB==false && sectionresultC==false ){
 

     
          document.getElementById('Oat-Section-Olist').innerHTML = "Sections Not yet Assigned!";
          document.getElementById('Oat-Section-Olist').style.color="red"
        }
    if(CheckAdmin==true){

      document.getElementById('Oat-Section-listA').style.display = "grid"; 
      document.getElementById('Oat-Section-listB').style.display = "grid"; 
      document.getElementById('Oat-Section-listC').style.display = "grid";
      document.getElementById('Oat-Section-listD').style.display = "grid";  
      
    }
   }
    

      
    

  return (
    <>
    <div className='oat-addmain'>
    <ToastContainer id="toast"
          position="top-center"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          /> 
          
          <div className="oat-addgrid-layout">
    <div className="oat-addmain-top">
        <div className='oat-addmain-back'>
          
        </div> 
          
           <span className='OatTitle'>
    <span>SECTION</span></span>
    <div className='oat-addmain-back'>
      <Link to="/OAT"><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i><br></br><span>Back</span></Link>
      </div> 
     </div>
 </div>


 <div id="Oat-ListSec">
 <ol id="Oat-Section-Olist">
    <li id="Oat-Section-listA" className='oatListA'>
        <div class="oaticon"></div>
        <div class="oattitle">Home</div>
        <div class="oatdescr"><Link to="/OatHome" id="OatSecHome">
        < i class="fa fa-home" aria-hidden="true"></i></Link>
        </div>
    </li>
    <li id="Oat-Section-listB" className='oatListB'>
        <div class="oaticon"></div>
        <div class="oattitle">Entities</div>
        <div class="oatdescr"><Link to="/OatEntity" id="OatSecEntities">
          < i class="fa fa-users" aria-hidden="true"></i></Link></div>
    </li>
    <li id="Oat-Section-listC" className='oatListC'>
        <div class="oaticon"></div>
        <div class="oattitle">Categories</div>
        <div class="oatdescr"><Link to="/OatCategory" id="OatSecCategories">
          < i class="fa fa-object-group" aria-hidden="true"></i></Link></div>
    </li>
    <li id="Oat-Section-listD" className='oatListD'>
        <div class="oaticon"></div>
        <div class="oattitle">Announcement</div>
        <div class="oatdescr"><Link to="/OatAnnouncement" id="OatSecAnnouncement" >
          <i class="fa fa-bell-o" aria-hidden="true"></i></Link></div>
    </li>
    </ol>



    </div>
    
    {pop? <div id="Loader">
<Oval
  height={40}
  width={50}

  color="black"
  wrapperStyle={{}}
  wrapperClass=""
  visible={true}
  ariaLabel='oval-loading'
  secondaryColor="gray"
  strokeWidth={2}
  strokeWidthSecondary={2}

/>
     </div>
 :null}
    </div>
    </>
  )
}

export default Oatsectionmain
